import { ICON_CHEVRON_RIGHT_PRIMARY, ICON_HINT_PRIMARY } from '../../../../modules/svg/svg'

import Image from 'next/image'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import useWebviewNavigation from '../../../../modules/hooks/webview/common/useWebviewNavigation'
import { s_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import { LESSON_ACTIVITIES_MAP, useLessonsStack } from '../../../../pages/[lang]/webview/lessons'

const RingleTip = ({ tag }: { tag: string | string[] }) => {
  const { navigate } = useWebviewNavigation()
  const { t } = useTranslation()
  const router = useAppRouter()
  const isWebview = useIsWebview()
  const { useLessonsFlow } = useLessonsStack()
  const { pop, push } = useLessonsFlow()
  const { lessonId, tab, highlightId, startDate, endDate } = router.query
  const isMobile = useIsMobile()

  const goToRingleTip = () => {
    const isStatistic =
      router?.asPath.includes('/portal/lessons/caf') || router.asPath.includes('/my-ringle/ai-analysis')
    if (isWebview) {
      push(LESSON_ACTIVITIES_MAP.AIRingleTipActivity, { tag })
    } else if (isMobile) {
      const url = urls.webview.caf.highlight.tip(tag)
      navigate({ url })
    } else if (isStatistic) {
      router.push(urls.student.newPortal.myRingle.AIAnalysis.asCafRingleTip(tab, startDate, endDate, tag, tag))
    } else {
      router.push(urls.student.newPortal.lessons.reviewDetail.asCafRingleTip(lessonId, tab, tag, highlightId))
    }
  }
  if (isMobile) {
    return (
      <div
        className="border-1 mb-16 flex items-center justify-between rounded-md border-gray-200 bg-gray-100 p-16"
        onClick={goToRingleTip}
      >
        <div className="flex items-center">
          <Image src={ICON_HINT_PRIMARY} width={20} height={20} alt="hint" className="mr-2" />
          <div className="text-h5 h-18 text-purple-500">{t(s_caf.highlight.ringletip)}</div>
        </div>
        <Image src={ICON_CHEVRON_RIGHT_PRIMARY} width={10} height={10} alt="arrow" />
      </div>
    )
  } else {
    return (
      <div
        className="border-1 mb-16 flex w-[100%] cursor-pointer items-center justify-between rounded-md border-gray-200 bg-gray-100 p-16"
        onClick={goToRingleTip}
      >
        <div className="flex items-center">
          <Image src={ICON_HINT_PRIMARY} width={20} height={20} alt="hint" className="mr-2" />
          <div className="text-h5 h-18 font-bold text-purple-500">{t(s_caf.highlight.ringletip)}</div>
        </div>
        <Image src={ICON_CHEVRON_RIGHT_PRIMARY} width={10} height={10} alt="arrow" />
      </div>
    )
  }
}

export default RingleTip
